import { PropTypes } from "prop-types";

export const ListTablePolicyShape = PropTypes.shape({
  $uri: PropTypes.string.isRequired,
  entity: PropTypes.shape({
    type: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    hide: PropTypes.bool
  }),
  service: PropTypes.shape({
    label: PropTypes.string.isRequired,
    hide: PropTypes.bool
  }),
  resource: PropTypes.shape({
    label: PropTypes.string.isRequired,
    hide: PropTypes.bool
  }),
  role: PropTypes.shape({
    label: PropTypes.string.isRequired,
    hide: PropTypes.bool
  })
});

export const ListTableColumnShape = PropTypes.shape({
  label: PropTypes.string.isRequired,
  key: PropTypes.string.isRequired
});
